import Vue from 'vue';
// @ts-ignore
import VTooltip from 'v-tooltip';

Vue.use(VTooltip, {
    defaultPlacement: 'bottom',
    defaultOffset: 10,
    defaultTemplate: '<div class="tooltip v-tooltip__content" style="z-index: 203"><span class="tooltip-inner"><span></div>',
});
